module.exports = __webpack_public_path__ + "static/1-106372dbd63ec141cd7d385f281a2976.jpg";